import Decimal from "decimal.js"
import { SmiPlan } from "../../types/supabase"

/**
 * Samaritan Ministries (SMI) plan-level limits, per the Guidelines for
 * Samaritan Classic/Basic. Only `iuaAmount` drives submission routing — the
 * per-need Initial Unshareable Amount that pre-discount bills must strictly
 * exceed before the need qualifies for sharing. The remaining fields feed UI
 * copy. Deliberately no annual or lifetime caps: SMI has none (do not copy
 * Sedera's three-IUAs-per-year cap).
 *
 * Mirrored in app/TodoReconciliation/Rules/Limits.php (smiIuaAmount) and the
 * memberships.smi_plan CHECK constraint — keep the three in sync.
 */
export const SMI_PLANS = {
  classic: {
    iuaAmount: new Decimal(1000),
    sharingPercentage: new Decimal(1),          // 100% above the IUA
    maxShareablePerNeed: new Decimal(250000),
    discountsReduceIua: false,                  // Classic stopped IUA reduction in 2020
  },
  basic: {
    iuaAmount: new Decimal(2000),
    sharingPercentage: new Decimal(0.9),        // 90% above the IUA
    maxCoShare: new Decimal(2500),              // max non-maternity co-share
    maxShareablePerNeed: new Decimal(247500),
    discountsReduceIua: true,                   // discounts reduce the IUA dollar-for-dollar
  },
} as const

export function getSmiPlanLimits(plan: SmiPlan) {
  return SMI_PLANS[plan]
}

export const LIMITS_2025 = {
  'qualifying_amount': new Decimal(1250),
  'personal_responsibility_amount': new Decimal(1250),
  'maternal_personal_responsibility_amount': new Decimal(2500)
} as const;

export const LIMITS_2024 = {
  'qualifying_amount': new Decimal(1000),
  'personal_responsibility_amount': new Decimal(1000),
  'maternal_personal_responsibility_amount': new Decimal(1500),
} as const;


export function getCurrentLimits() {
  const year = new Date().getFullYear()
  if (year <= 2024) {
    return LIMITS_2024
  }
  return LIMITS_2025
}

export function getLimits(date: Date) {
  const year = date.getFullYear()
  if (year <= 2024) {
    return LIMITS_2024
  }
  return LIMITS_2025
}
